import { defined } from "@entrilia/shared/utilities/typeHelper.ts";
import { createContext, use } from "react";
import type { BiAggregation } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../../../api/types/svTypes.ts";

export type SupportedAggregationsType = {
  aggregations: BiAggregation[];
  getSupportedAggregationTypes: (field: ReportField) => BiAggregation[];
};

export const SupportedAggregationsContext = createContext<SupportedAggregationsType | undefined>(undefined);

export const useSupportedAggregationsContext = () => {
  const context = use(SupportedAggregationsContext);
  return defined(context);
};
